<template>
    <v-app>
        <v-app-bar app color="teal darken-3" dark elevation="4" height="70">
            <router-link to="/main/home" class="d-flex align-center" style="text-decoration: none;">
                <h2 class="teal--text text--lighten-3 mr-6">
                    <strong>WP</strong>
                </h2>
            </router-link>

            <v-divider vertical inset class="mr-4"></v-divider>

            <v-toolbar-items>
                <template v-for="(group, index) in menu">
                    <v-menu :key="index" offset-y open-on-hover transition="slide-y-transition">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text v-bind="attrs" v-on="on" :class="{ 'active-parent': isGroupActive(group) }">
                                <v-icon left :color="isGroupActive(group) ? 'teal lighten-3' : ''">{{ group.icon
                                    }}</v-icon>
                                {{ group.text }}
                                <v-icon right small>mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense color="teal darken-4" dark>
                            <v-list-item v-for="(subitem, i) in group.submenu" :key="i" :to="subitem.route" link
                                active-class="teal lighten-1--text">
                                <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-chip class="ma-2" color="teal darken-4" label text-color="teal lighten-4">
                <v-icon left small>mdi-account</v-icon>
                <span class="font-weight-bold text-uppercase" style="font-size: 0.75rem;">
                    {{ username }}
                </span>
            </v-chip>
            <v-divider vertical inset class="mx-2" style="height: 35px; align-self: center;"></v-divider>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" href="/manual_usuario.pdf" target="_blank"
                        color="teal lighten-4" class="mx-1">
                        <v-icon>mdi-help-circle-outline</v-icon>
                    </v-btn>
                </template>
                <span>Manual de Usuario</span>
            </v-tooltip>
            <v-divider vertical inset class="mx-2" style="height: 35px; align-self: center;"></v-divider>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" @click="$store.commit('logout')" color="teal lighten-3">
                        <v-icon>mdi-logout</v-icon>
                    </v-btn>
                </template>
                <span>Cerrar Sesion</span>
            </v-tooltip>
        </v-app-bar>


        <v-main class="grey lighten-2">
            <v-container fluid>
                <RouterView />
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            drawer: true,
        }
    },
    computed: {
        ...mapGetters(['getMenuItems']),

        username() {
            return this.$store.state.username
        },
        menu() {
            //console.log(this.getMenuItems);
            const rawMenu = this.getMenuItems;
            const newMenu = [];

            rawMenu.forEach(group => {
                if (group.text === 'Maestros') {
                    newMenu.push({
                        ...group,
                        text: 'Registro de parámetros',
                        submenu: group.submenu.filter(s => s.text === 'Servicios')
                    });
                }
                else if (group.text === 'Gestion') {
                    const objHijo1 = group.submenu.find(s => s.text === 'Volumen / Transacciones');
                    newMenu.push({
                        text: 'Registro objetivos',
                        icon: 'mdi-target',
                        submenu: [objHijo1]
                    });

                    const objHijo2 = group.submenu.find(s => s.text === 'Planificacion');
                    newMenu.push({
                        text: 'Planificación',
                        icon: 'mdi-calendar-clock', // Icono de calendario/plan
                        submenu: [objHijo2]
                    });
                }
                else {
                    newMenu.push(group);
                }
            });

            return newMenu;
            //return this.getMenuItems;
        },
    },
    methods: {
        isGroupActive(group) {
            if (!group || !group.submenu) return false;

            // Comparamos la ruta actual (this.$route.path) con las rutas del submenú
            return group.submenu.some(subitem => this.$route.path === subitem.route);
        }
    }
}
</script>

<style>
#inspire {
    background-color: #f3f3f3;
}


.v-list-group--active-teal.v-list-item--active>.v-list-group__header .v-list-item__title,
.v-list-group--active-teal.v-list-item--active>.v-list-group__header .v-list-item__icon,
.v-list-group--active-teal.v-list-item--active>.v-list-group__header .v-list-item__icon--group {
    color: #80CBC4 !important;
}

.menu-active-teal-dark {
    background-color: #00897B !important;
    border-left: 4px solid #80CBC4;
}

.menu-active-teal-dark .v-list-item__title,
.menu-active-teal-dark .v-icon {
    color: #FFFFFF !important;
}

.menu-active-teal-dark .v-icon {
    color: #80CBC4 !important;
}

.menu-active-teal-light {
    background-color: #E0F2F1 !important;
    color: #004D40 !important;
    border-left: 4px solid #009688;
}

.menu-active-teal-light .v-icon {
    color: #004D40 !important;
}

.v-btn.teal.lighten-3 .v-icon {
    color: #004D40 !important;
}

.v-navigation-drawer.dark .logo-link h2 {
    color: #80CBC4 !important;
}

.active-parent {
    background-color: rgba(255, 255, 255, 0.1) !important;
    /* Fondo sutil */
    border-bottom: 4px solid #B2DFDB !important;
    /* Línea teal clara abajo */
    color: #B2DFDB !important;
    /* Texto teal claro */
    border-radius: 0;
    /* Para que la línea llegue a los bordes */
}

/* Ajuste para que los botones de la barra ocupen toda la altura */
.v-btn--text {
    height: 100% !important;
}
</style>